<script>
export default {
    name: 'InAppBrowserModal',

    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },

    mounted() {
        const wrapper = this.$el.parentElement
        wrapper.style.alignSelf = 'flex-start'
        wrapper.style.marginTop = '5px'
    },

    beforeDestroy() {
        const wrapper = this.$el.parentElement
        wrapper.style.alignSelf = ''
        wrapper.style.marginTop = ''
    },

    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>

<template>
    <div :class="$style.modal">
        <BaseIcon
            name="pointer-arrow-pink"
            :class="$style.arrow"
            aria-hidden="true"
        />
        <p
            :class="$style.headline"
            data-test="headline"
        >
            Looks like you're on Instagram or Facebook. To go straight to the content shared in-app:
        </p>

        <div :class="$style.steps">
            <div
                :class="$style.step"
                data-test="step"
            >
                <span
                    :class="$style.stepNumber"
                    data-test="step-number"
                >1</span>
                <p :class="$style.stepText">
                    Tap the <strong>3 dots (...)</strong> on the upper right.
                </p>
            </div>

            <div
                :class="$style.step"
                data-test="step"
            >
                <span
                    :class="$style.stepNumber"
                    data-test="step-number"
                >2</span>
                <p :class="$style.stepText">
                    Tap <strong>Open in external browser</strong>
                </p>
            </div>
        </div>

        <button
            :class="$style.dismiss"
            data-test="dismiss"
            @click="close"
        >
            Dismiss
        </button>
    </div>
</template>

<style module lang="scss">
@use '@design' as *;

.modal {
    position: relative;
    width: calc(100vw - #{$s-xxl});
    max-width: 420px;
    padding: $s-xxl $s-xl $s-xl;
    overflow: visible;
    background: $c-shark-grey;
    border: none;
    border-radius: $s-m;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.arrow {
    position: absolute;
    top: 10px;
    right: -10px;
    width: 80px;
    height: auto;
    pointer-events: none;
}

.headline {
    margin: 0 0 $s-xl 0;
    padding-right: 70px;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.45;
    color: $c-white;
    letter-spacing: -0.36px;
}

.steps {
    display: flex;
    flex-direction: column;
    gap: $s-m;
    margin-bottom: $s-xl;
}

.step {
    display: flex;
    gap: $s-m;
    align-items: center;
}

.stepNumber {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.45;
    color: $c-white;
    letter-spacing: -0.36px;
    background: $c-black;
    border-radius: 50%;
}

.stepText {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.45;
    color: $c-white;
    letter-spacing: -0.28px;

    strong {
        font-weight: 700;
    }
}

.dismiss {
    display: block;
    width: 100%;
    padding: $s-xs 0;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.45;
    color: $c-white;
    letter-spacing: -0.26px;
    text-align: center;
    cursor: pointer;
    background: none;
    border: none;

    &:active {
        opacity: 0.7;
    }
}
</style>
